import React from 'react';
import { Link } from 'react-router-dom';
import { FaTruck, FaPills, FaShippingFast, FaCheckCircle, FaClock, FaHeadset } from 'react-icons/fa';
import './FeaturedServices.css';

function FeaturedServices() {
  return (
    <div className="featured-services">
      {/* Delivery CTA Section */}
      <div className="delivery-cta-section">
        <div className="delivery-cta-container">
          <div className="delivery-cta-content">
            <div className="delivery-cta-text">
              <h2>Get Your Medications Delivered to Your Doorstep!</h2>
              <p>
                Experience the convenience of our pharmacy delivery service. 
                Order your medications from the comfort of your home and have them 
                delivered safely and quickly.
              </p>
              <div className="delivery-features">
                <div className="feature-item">
                  <FaCheckCircle />
                  <span>Same Day Delivery</span>
                </div>
                <div className="feature-item">
                  <FaClock />
                  <span>Available 24/7</span>
                </div>
                <div className="feature-item">
                  <FaHeadset />
                  <span>Expert Support</span>
                </div>
              </div>
              <Link to="/delivery" className="cta-button delivery-btn">
                <FaTruck /> Order Delivery Now
              </Link>
            </div>
            <div className="delivery-cta-visual">
              <div className="delivery-illustration">
                <div className="delivery-truck">🚚</div>
                <div className="delivery-package">📦</div>
                <div className="delivery-pills">💊</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Products Showcase Section */}
      <div className="products-showcase-section">
        <div className="products-showcase-container">
          <div className="products-showcase-header">
            <h2>Quality Products You Can Trust</h2>
            <p>Discover our wide range of pharmaceutical products and medical supplies</p>
          </div>

          <div className="products-grid">
            <div className="product-showcase-card">
              <div className="product-icon">
                <FaPills />
              </div>
              <h3>Prescription Drugs</h3>
              <p>High-quality prescription medications for all your healthcare needs</p>
              <ul className="product-highlights">
                <li>✓ Anti-Hypertensive</li>
                <li>✓ Anti-Diabetics</li>
                <li>✓ Corticosteroids</li>
              </ul>
            </div>

            <div className="product-showcase-card featured">
              <div className="featured-badge">POPULAR</div>
              <div className="product-icon">
                🩺
              </div>
              <h3>Rapid Diagnostics</h3>
              <p>Fast and accurate diagnostic test kits for quick results</p>
              <ul className="product-highlights">
                <li>✓ Malaria Test Kits</li>
                <li>✓ Pregnancy Tests</li>
                <li>✓ Blood Glucose Tests</li>
              </ul>
            </div>

            <div className="product-showcase-card">
              <div className="product-icon">
                🏥
              </div>
              <h3>Medical Supplies</h3>
              <p>Complete range of surgical supplies and medical instruments</p>
              <ul className="product-highlights">
                <li>✓ Surgical Equipment</li>
                <li>✓ Medical Instruments</li>
                <li>✓ First Aid Supplies</li>
              </ul>
            </div>
          </div>

          <div className="products-cta">
            <Link to="/products" className="cta-button products-btn">
              View All Products
            </Link>
          </div>
        </div>
      </div>

      {/* Quick Stats Section */}
      <div className="stats-section">
        <div className="stats-container">
          <div className="stat-item">
            <div className="stat-number">7</div>
            <div className="stat-label">Branches Nationwide</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">25+</div>
            <div className="stat-label">Years of Experience</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">1000+</div>
            <div className="stat-label">Quality Products</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">24/7</div>
            <div className="stat-label">Customer Support</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeaturedServices;
